import { render, staticRenderFns } from "./Subarea.vue?vue&type=template&id=78208684"
import script from "./Subarea.vue?vue&type=script&lang=js"
export * from "./Subarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports